/* eslint-disable */
import config from '../../../config'
import styles from './index.module.scss'
import text from './text.json'
import React, { useState, useLayoutEffect, useEffect, useContext } from 'react'
import { SlideArrow } from '../../../icons'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import './styles.css'
import { Mousewheel } from 'swiper'
import { PageContext } from '../../../context/PageContextProvider'
import TeamAPI from '../../../api/team'
import Loading from '../loading'

const Team = () => {
  const { language } = useContext(PageContext)
  const [current, setCurrent] = useState(0)
  const [width, setWidth] = useState(true)
  const [my_swiper, set_my_swiper] = useState({})
  const [start, setStart] = useState(true)
  const [end, setEnd] = useState(false)
  const [present, setPresent] = useState(4)
  const [len, setLen] = useState(0)
  const [members, setMembers] = useState([])
  const [load, setLoad] = useState(false)
  useEffect(() => {
    (async () => {

    const { data } = await TeamAPI.getAll()
    await setMembers(data)
    await setLen(data.length)
    await setLoad(true)
  
    })();
  }, [])
  const linkBuilder = (url) => {
    if (!url) return ''
    return url.startsWith('http') ? url : config.API_URL + url
  }
  useLayoutEffect(() => {
    function updateSize() {
      if (window.innerWidth < 768) {
        setWidth(false)
        return
      }
      setWidth(true)
    }
    window.addEventListener('resize', updateSize)
    updateSize()
  }, [])
  if (!load) return <Loading />
  if (!members || members.length === 0) return null

  return (
    <section className={styles.container}>
      <div className={styles.header}>
        <article>
          <span>{text.ours[language]}</span>
          <h2>{text.team[language]}</h2>
        </article>

        {len > 6 && width ? (
          <div>
            <span
              style={start ? { opacity: '0.5', pointerEvents: 'none' } : null}
              onClick={() => {
                let x = present - 1
                setPresent(x)
                my_swiper.slidePrev()
                setEnd(my_swiper.isEnd)
                setStart(my_swiper.isBeginning)
              }}
            >
              <SlideArrow />
            </span>
            <span
              style={end ? { opacity: '0.5', pointerEvents: 'none' } : null}
              onClick={() => {
                let x = present + 1
                setPresent(x)
                my_swiper.slideNext()
                setEnd(my_swiper.isEnd)
                setStart(my_swiper.isBeginning)
              }}
            >
              <SlideArrow />
            </span>
          </div>
        ) : null}
      </div>
      <div className={styles['swiper-container']}>
        <Swiper
          modules={[Mousewheel]}
          mousewheel={{ forceToAxis: true, releaseOnEdges: true, sensitivity: 1 }}
          onSlideChange={(e) => {
            set_my_swiper(e)
            setEnd(e.isEnd)
            setStart(e.isBeginning)
          }}
          slidesPerView={'auto'}
          spaceBetween={0}
          className="swiper-teams"
        >
          {members.map((item, i) => (
            <SwiperSlide key={i}>
              <div
                onClick={() => {
                  setCurrent(i)
                }}
                className={`${styles.card} ${
                  current === i ? styles.active : null
                } member bpg-card-neon`}
              >
                <figure
                  style={{
                    backgroundImage: `url('${linkBuilder(
                      item.photoLocation,
                    )}')`,
                  }}
                />
                <p>{item.fullname?.[language] || ''}</p>
                <span>{item.profession?.[language] || ''}</span>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className={styles.infoWrapper}>
        <div className={styles.info}>
          <div>
            <span>{members[current]?.profession?.[language] || ''}</span>
            <h2>{members[current]?.fullname?.[language] || ''}</h2>
            <div
              className={styles.teamDescription}
              dangerouslySetInnerHTML={{
                __html: members[current]?.description?.[language] || '',
              }}
            />
          </div>
          <figure>
            <img
              src={linkBuilder(members[current]?.photoLocation)}
              alt={members[current]?.fullname?.[language] || ''}
            />
          </figure>
        </div>
      </div>
    </section>
  )
}

export default Team
